import type { ListingDetails } from 'app/types/listingDetails.type';
import { useDetailPanel } from '../../../ui/DetailPanel';
import { ApplySpoke } from './ApplySpoke';

export const ApplySpokeContent = ({ config }: { config?: unknown }) => {
  const { closePanel } = useDetailPanel();
  const listing = (config as { listing?: ListingDetails } | undefined)?.listing;

  return <ApplySpoke onClose={closePanel} listing={listing} />;
};
